import React, { useState, ReactNode } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./tabs-components";

// Define the structure for each tab item
interface TabItem {
    id: string;
    title: string;
    component: ReactNode;
    disabled?: boolean; // Optional property to disable a tab
}

// Updated props interface
interface TabSwitchProps {
    tabs: TabItem[]; // Array of tab configurations
    defaultTabId?: string; // ID of the default active tab
    className?: string;
}

const TabSwitch: React.FC<TabSwitchProps> = ({
    tabs,
    defaultTabId,
    className = "",
}) => {
    // If defaultTabId is not provided, use the first tab's id
    const initialTabId = defaultTabId || (tabs.length > 0 ? tabs[0].id : "");
    const [activeTab, setActiveTab] = useState<string>(initialTabId);

    return (
        <div className={`w-full min-w-[800px] ${className}`}>
            {tabs.length > 0 ? (
                <Tabs
                    defaultValue={initialTabId}
                    value={activeTab}
                    onValueChange={setActiveTab}
                    className="w-full"
                >
                    <TabsList className="flex w-full mb-6">
                        {tabs.map((tab) => (
                            <TabsTrigger
                                key={tab.id}
                                value={tab.id}
                                disabled={tab.disabled}
                                className="flex-1"
                            >
                                {tab.title}
                            </TabsTrigger>
                        ))}
                    </TabsList>

                    {tabs.map((tab) => (
                        <TabsContent
                            key={tab.id}
                            value={tab.id}
                            className="mt-2"
                        >
                            {tab.component}
                        </TabsContent>
                    ))}
                </Tabs>
            ) : (
                <div className="text-center py-4 text-gray-500">
                    No tabs available
                </div>
            )}
        </div>
    );
};

export default TabSwitch;
